// src/services/financeAdminService.js
// Updated: Tuesday, August 4, 2026 at 8:25 PM EDT

import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const setFinanceRoleCallable = httpsCallable(functions, 'setFinanceRole');

export const setFinanceRole = async ({ userId, financeRole, reason }) => {
  const result = await setFinanceRoleCallable({ userId, financeRole, reason });
  return result.data;
};
